// extracted by mini-css-extract-plugin
module.exports = {"relaxUs":"RelaxUs_relaxUs__N9TX6","relaxDataImage":"RelaxUs_relaxDataImage__hM5gA","relaxImage":"RelaxUs_relaxImage__TtFOn","relaxData":"RelaxUs_relaxData__GfH_H"};